import * as React from 'react';
import { cx } from '../utils';
import type { StyledProps, WithChildren } from '../types';
import type { UnsafeStyleProps } from '../escape-hatches';

/* PanelTint — audit #9 rename (2026-05-16). v4 poetic aliases replaced
   with v5 semantic names matching the `--color-{tint}-*` token series.
   `neutral` retained for the default un-tinted panel surface. */
export type PanelTint = 'theme' | 'success' | 'error' | 'warning' | 'info' | 'neutral';

export interface ColorPanelProps extends StyledProps, WithChildren, UnsafeStyleProps {
  tint?: PanelTint;
  title?: React.ReactNode;
}

export function ColorPanel({
  tint = 'neutral',
  title,
  children,
  className,
  unsafe_style,
}: ColorPanelProps) {
  return (
    <div className={cx('j-panel', `j-panel-${tint}`, className)} style={unsafe_style}>
      {title && <div className="j-panel-header">{title}</div>}
      {children}
    </div>
  );
}
